import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { CoreTranslateModule, provideTranslationLoader } from '@core/translate';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ReviewEntryContainerComponent,
  ReviewOverviewContainerComponent,
  ReviewScoreContainerComponent,
  ReviewSingleContainerComponent,
  ReviewsLegacyModule,
} from '@reviews/legacy';

import { ReviewEntrySectionContainerComponent } from './review-entry-section-container/review-entry-section-container.component';

const namespace = 'reviewsFeature';

@NgModule({
  imports: [
    ReviewsLegacyModule,
    CoreTranslateModule,
    provideLazyLoad({
      ReviewEntrySection: ReviewEntrySectionContainerComponent,

      // Legacy components (only compatible with DynamicRow)
      Review: ReviewSingleContainerComponent,
      ReviewScoreWidget: ReviewScoreContainerComponent,
      ReviewEntry: ReviewEntryContainerComponent,
      ReviewOverview: ReviewOverviewContainerComponent,
    }),
  ],
  providers: [
    provideTranslationLoader(
      namespace,
      (name) => import(`./i18n/${name}.json`)
    ),
  ],
})
export class ReviewsLazyModule {}
